require('../modules/es6.object.to-string');

require('../modules/es6.string.iterator');

require('../modules/web.dom.iterable');

require('../modules/es6.promise');

module.exports = require('../modules/_core').Promise;